import { useContext } from "react";
import { LocalizedAppContext } from "src/app/components/LocalizedAppContext";

export const useLocalizedAppContext = () => useContext(LocalizedAppContext);
